/**
 * Ryan O'Dowd
 * 2024-12-04
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  ImageBackground,
  View,
} from 'react-native';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const SNOW_GIF = require('@assets/img/snow.gif');
const SNOW2_GIF = require('@assets/img/snow2.gif');

const ChristmasBackground = () => {
  const styles = hooks.useStyles(getStyles);

  const isSnowOn = true; // @TODO: make this toggleable in settings

  return (
    <View style={styles.container}>
      {isSnowOn && (
        <React.Fragment>
          <ImageBackground
            style={styles.backgroundImageWrapper}
            imageStyle={styles.snow}
            source={SNOW_GIF}
          />
          <ImageBackground
            style={styles.backgroundImageWrapper}
            imageStyle={styles.snow}
            source={SNOW2_GIF}
          />
        </React.Fragment>
      )}
    </View>
  );
};

export default ChristmasBackground;
